__turbopack_context__.v({
  "section": "article-thumbnails-module-scss-module__hoRXQa__section",
});
